import { call, put, takeEvery } from 'redux-saga/effects';
import { SEND_OTP, VERIFY_OTP } from "../actionTypes";
import { apiCall } from "../../services";
import { history } from "../../utils/history";
import {  setLoader, removeLoader, loginActionSuccess } from "../actions"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function* sendOTP(actions) {
	yield put(setLoader());

	const sendOTPAction = yield apiCall({ body: {...actions.data},url:'send_otp'});
	
	if (sendOTPAction) {
		yield put(removeLoader());
		if(sendOTPAction.data.success){
			actions.callback && actions.callback(sendOTPAction.data)
		}else {
			const options = {
				autoClose: 2500,
				hideProgressBar: true,
				position: toast.POSITION.BOTTOM_CENTER,
				closeButton: false,
				draggable: false,
				pauseOnFocusLoss: false,
				closeOnClick: false
			};
			toast.error(sendOTPAction.data.msg, options)
		} 
	} 
}
function* verifyOTP(actions) {
	yield put(setLoader());

	const verifyOTPAction = yield apiCall({ body: {...actions.data},url:'verify_otp'});
	
	if (verifyOTPAction) {
		yield put(removeLoader());
		if(verifyOTPAction.data.success){
			actions.callback && actions.callback(verifyOTPAction.data)
		}else {
			const options = {
				autoClose: 2500,
				hideProgressBar: true,
				position: toast.POSITION.BOTTOM_CENTER,
				closeButton: false,
				draggable: false,
				pauseOnFocusLoss: false,
				closeOnClick: false
			};
			toast.error(verifyOTPAction.data.msg, options)
		} 
	} 
}

export default function* root() {
  	yield takeEvery(SEND_OTP, sendOTP);
  	yield takeEvery(VERIFY_OTP, verifyOTP);
}